<app-custom-modal customTitle="Editar perfil" (closeFunction)="closeFunction.emit()" (acceptFunction)="save()">
    <form [formGroup]="form" class="space-y-4">

        <custom-input [autofocus]="true" label="Nombre" type="text"
            [formControlItem]="form.get('name')"></custom-input>

        <custom-input label="Nombre de usuario (opcional, para iniciar sesión)" type="text"
            [formControlItem]="form.get('username')" [errorMessages]="usernameErrors"></custom-input>

        <custom-input label="Email" type="email"
            [formControlItem]="form.get('email')"></custom-input>

        <custom-input label="Nueva contraseña (dejar vacío para no cambiar)" type="password"
            [formControlItem]="form.get('password')"></custom-input>

    </form>
</app-custom-modal>
